export enum EDateFormats {
  date = 'MM/dd/yyyy',
  'yyyy/MM/dd' = 'yyyy/MM/dd',
  'dd/MM/yyyy HH:mm:ss' = 'dd/MM/yyyy HH:mm:ss',
  'yyyyMMddhhmm' = 'yyyyMMddhhmm',
  'dd-MM-yyyy HH:ii' = 'dd-MM-yyyy HH:ii',
}

export const DateFormatOptions = [
  'dd/MM/yyyy',
  'yyyy/MM/dd',
  'MM/dd/yyyy',
  'dd/MM/yy',
  'MM/dd/yy',
];
